function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "What's New");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 1a3.75 3.75 0 013 6h1.75c.966 0 1.75.784 1.75 1.75v2.5c0 .698-.409 1.3-1 1.582v8.418A1.75 1.75 0 0120.25 23H3.75A1.75 1.75 0 012 21.25v-8.418a1.75 1.75 0 01-1-1.582v-2.5C1 7.784 1.783 7 2.75 7H4.5a3.75 3.75 0 013-6c1.455 0 3.436.901 4.5 3.11C13.064 1.901 15.044 1 16.5 1zm3.48 12h-6.954v7.992h6.73a.23.23 0 00.224-.235V13zM11 13H4.013v7.757c0 .13.101.235.226.235h6.76V13zm9.812-4.052h-7.786v2.104h7.786c.126 0 .229-.078.229-.175V9.123c0-.097-.103-.175-.23-.175zm-9.812 0H3.214c-.126 0-.229.078-.229.175v1.754c0 .097.103.175.23.175H11V8.948zM7.612 2.64a1.98 1.98 0 000 3.96h3.274c-.253-3.074-2.263-3.96-3.274-3.96zm8.776 0c-1.011 0-3.021.886-3.274 3.96h3.274a1.98 1.98 0 000-3.96z",
  fill: "#000",
  fillRule: "nonzero"
});

var SvgGiftIcon = function SvgGiftIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGiftIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift-icon.363188aa.svg";
export { ForwardRef as ReactComponent };